import React, { useEffect, useRef, useState } from 'react';
import { Input, Button, InputRef } from 'antd';
import { StyledSearch } from './styled';
import { SearchOutlined } from '@ant-design/icons';

function Search({ onSearch, searchText: text }) {
  const [searchText, setSearchText] = useState(text);
  const inputRef = useRef<InputRef>(null);
  const [collapsed, setCollapsed] = useState(!text || !searchText);

  const expand = () => {
    setCollapsed(false);

    setTimeout(() => {
      inputRef.current!.focus({
        cursor: 'start',
      });
    });
  };

  const onChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  // to handle request for all results on clear without enter
  useEffect(() => {
    if (!searchText) {
      onSearch(searchText);
    }
  }, [onSearch, searchText]);

  const handleSearch = () => {
    onSearch(searchText);
  };

  const handleBlur = () => {
    if (!searchText) {
      setCollapsed(true);
    }
  };

  return (
    <StyledSearch onClick={(event) => event.stopPropagation()}>
      {collapsed ? (
        <Button icon={<SearchOutlined />} type="text" onClick={expand} />
      ) : (
        <Input.Search
          ref={inputRef}
          placeholder="Search"
          allowClear
          autoFocus
          value={searchText}
          onChange={onChangeSearch}
          onSearch={handleSearch}
          style={{ width: 200 }}
          onBlur={handleBlur}
        />
      )}
    </StyledSearch>
  );
}

export default Search;
